/**
 * Handles tab functionality for Loyalty Favorites LP
 *
 * @module loyaltyFavorites
 */

import $ from "jquery";

$(() => {
  // Should only run if we're on a loyalty favorites LP
  if ($('.loyalty-favorites').length) {
    const $tabs = $('.loyalty-favorites__tabs');
    const $content = $('#loyalty-favorites-content');
    const $tabAlert = $('#loyalty-tab-alert');
    const $products = $content.find('.loyalty-favorites__products');
    const $loadingSkeleton = $('#loading-skeleton');
    const ACTIVE_CLASS = 'tabs__link--active';

    $tabs.on('click', '[data-tab]', function() {
      let tab = $(this).data('tab');
      const $clickedTab = $(this).closest('.loyalty-favorites__tab');

      if ($clickedTab.hasClass(ACTIVE_CLASS)) {
        return;
      }

      $loadingSkeleton.removeClass('u-hide');
      $products.removeClass('loaded').addClass('u-hide');

      $tabs.find('.loyalty-favorites__tab').removeClass(ACTIVE_CLASS).attr('aria-selected', 'false');
      $clickedTab.addClass(ACTIVE_CLASS).attr('aria-selected', 'true');

      $.ajax({
        url: `ajax/${tab}.jsp`,
        dataType: 'html',
        success: function(html) {
          $products.html(html);
          waitForFirstRowImages();
          $products.find('.js-lazy-image').lazy();
          if (tab === 'vip') {
            tab = tab.toUpperCase();
          }
          $tabAlert.text(`${tab} tier product listing loaded`);
        },
        error: function(err) {
          console.error("Error loading Loyalty Favorites HTML content", err);
        },
      });
    });

    function waitForFirstRowImages() {
      const $images = $('#loyalty-favorites-content .n-block-grid--5 li .product-image');
      if ($images.length <= 5) {
        return hideSkeletonAndShowProducts();
      }
      // Select first 5 above the fold images
      const $firstRowImages = $('#loyalty-favorites-content .n-block-grid--5 li:lt(5) img');
      let imagesLoaded = 0;

      $firstRowImages.each(function() {
        if (this.complete) { // Check if image is already cached
          imagesLoaded++;
          if (imagesLoaded === $firstRowImages.length) {
            hideSkeletonAndShowProducts();
          }
        } else {
          $(this).on('load', function() {
            imagesLoaded++;
            if (imagesLoaded === $firstRowImages.length) {
              hideSkeletonAndShowProducts();
            }
          });
        }

        $(this).on('error', function() {
          imagesLoaded++;
          if (imagesLoaded === $firstRowImages.length) {
            hideSkeletonAndShowProducts();
          }
        });

      });

      // Handle case where there are no images in the first row
      if ($firstRowImages.length === 0) {
        hideSkeletonAndShowProducts();
      }
    }

    function hideSkeletonAndShowProducts() {
      $loadingSkeleton.addClass('u-hide');
      $products.removeClass('u-hide').addClass('loaded');
      if (typeof window.bindHeartEvent === 'function') {
        window.bindHeartEvent($('#loyalty-favorites-content .js-favorite-button'));
      }
    }
  }
});


// WEBPACK FOOTER //
// ./src/scripts/entry-points/plp/loyalty-favorites.js